import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import PageLoader from "../global/page-loader";
import { QRCodeCanvas } from "qrcode.react";
import { route } from "../global/route.global";
import axios from "axios";

function CustomeratisfactionSurvey() {
  const [showForm, setShowForm] = React.useState(false);
  const [formData, setFormData] = React.useState({
    // Initial form data structure
    acceptPrivacyNotice: false,
    name: "",
    respondentName: "",
    city: "",
    accountNumber: "",
    email: "",
    contactNumber: "",
    reconnectionTime: "",
    serviceReturnSpeed: "",
    voltageIssues: "",
    reconnectionAfterPayment: "",
    serviceCourtesy: "",
    suggestions: "",
  });

  const QRCodeWithLogo = ({ value, logoUrl, title, size = 200 }) => {
    const canvasRef = React.useRef();

    return (
      <div ref={canvasRef}>
        <QRCodeCanvas
          value={value}
          size={size}
          title={title}
          bgColor={"#ffffff"}
          fgColor={"#000000"}
          level={"H"}
        />{" "}
        <img
          src={logoUrl}
          alt="Logo"
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "35px", // Adjust logo size
            height: "60px",
            borderRadius: "10%", // Optional: Makes the logo circular
          }}
        />
      </div>
    );
  };

  const submitCss = () => {
    // Handle form submission logic here
    console.log("Form submitted with data:", formData);
    axios
      .post(route.root.css, formData)
      .then((response) => {
        // console.log("Form submitted successfully:", response.data);
        alert("Salamat sa inyong pagsagot sa survey!");
      })
      .catch((error) => {
        // if code is 400 , you have already submitted the survey
        if (error.response && error.response.status === 400) {
          alert(
            "Mayroon ka nang naisagawang pagsusumite ng survey. Salamat sa iyong oras!"
          );
          return;
        } else {
          alert(
            "May nangyaring error sa pagsusumite ng survey. Pakisubukan muli."
          );
        }
      });
    // Reset form data after submission
    // setFormData({
    //   acceptPrivacyNotice: false,
    //   name: "",
    //   respondentName: "",
    //   city: "",
    //   accountNumber: "",
    //   email: "",
    //   contactNumber: "",
    //   reconnectionTime: "",
    //   serviceReturnSpeed: "",
    //   voltageIssues: "",
    //   reconnectionAfterPayment: "",
    //   serviceCourtesy: "",
    //   suggestions: "",
    // });
    // setShowForm(false); // Hide the form after submission
  };

  return (
    <>
      <PageLoader />
      <div className="breadcrumb-wrapper">
        <div className="images-overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="page-heading">
                <h1>Customer Satisfaction Survey</h1>
                <span className="line"></span>
              </div>
              <div className="page-breadcrumb-inner">
                <div className="page-breadcrumb">
                  <div className="breadcrumb-list">
                    <ul>
                      <li>
                        <Link to="/" activeclass="active">
                          Home
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/customer-satisfaction-survey"
                          activeclass="active"
                        >
                          Customer Satisfaction Survey
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-12">
            <form>
              <div className="form-group">
                <h1 className="mt-5 mb-4">
                  <strong className="font-bold">Privacy Notice</strong>
                </h1>
                <div className="row">
                  <div className="col col-lg-8 col-md-8 col-sm-12">
                    <p className="text-md">
                      Ang inyong sagot ay gagamitin lamang upang mapabuti ang
                      serbisyo ng PANELCO I. Tanging awtorisadong empleyado
                      lamang ang may access sa datos na ito. Ang staff na inyong
                      narate ay walang access sa inyong indibidwal na puna.
                    </p>
                    <p>
                      Sa pagsusumite ng survey na ito, kayo ay nagbibigay ng
                      pahintulot sa pagkuha at pagproseso ng inyong impormasyon
                      alinsunod sa Data Privacy Act of 2012.
                    </p>
                    <p>
                      Para sa anumang katanungan, makipag-ugnayan sa aming Data
                      Protection Officer sa
                      dataprivacyofficer.panelcoi@gmail.com.
                    </p>
                    <div className="form-check mb-3">
                      <label
                        htmlFor="accept-privacy-notice"
                        className="d-flex font-weight-bold"
                      >
                        <input
                          type="checkbox"
                          name="accept-privacy-notice"
                          onChange={(e) => {
                            if (e.target.checked) {
                              setShowForm(true);
                            } else {
                              setShowForm(false);
                            }
                            setFormData({
                              ...formData,
                              acceptPrivacyNotice: e.target.checked,
                            });
                          }}
                          className="form-check-input me-2"
                          id="accept-privacy-notice"
                          value={true}
                          required
                        />
                        <span>Sumasang-ayon ako sa Privacy Notice</span>
                      </label>
                    </div>
                  </div>
                  <div className="col">
                    <div style={{ textAlign: "center" }}>
                      <QRCodeWithLogo
                        value="https://panelcoi.com/customer-satisfaction-survey"
                        title="PANELCO I Customer Satisfaction Survey"
                        logoUrl="https://panelcoi.com/assets/images/global/logo-02.png"
                        size={250}
                      />
                      <p className="font-weight-bold">Survey QR Code</p>
                    </div>
                  </div>
                </div>
              </div>
              {showForm ? (
                <div className="row">
                  <div className="col-8">
                    <div className="form-group">
                      <label htmlFor="name" className="font-weight-bold">
                        1. Pangalan ng Member-Consumer-Owner *
                      </label>
                      <div className="form-check">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              name: e.target.value,
                            });
                          }}
                          id="name"
                          placeholder="Juan Dela Cruz"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="respondentName"
                        className="font-weight-bold"
                      >
                        2. Pangalan ng Respondent *
                      </label>
                      <div className="form-check">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              respondentName: e.target.value,
                            });
                          }}
                          id="respondentName"
                          placeholder="Juan Dela Cruz"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="city" className="font-weight-bold">
                        3. Pangalan ng City/Municipality *
                      </label>
                      <div className="form-check">
                        <select
                          name="city"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              city: e.target.value,
                            });
                          }}
                          id="city"
                          required
                        >
                          <option value="">Pumili ng City/Municipality</option>
                          <option value="AGNO">AGNO</option>
                          <option value="ANDA">ANDA</option>
                          <option value="ALAMINOS CITY">
                            CITY OF ALAMINOS
                          </option>
                          <option value="MABINI">MABINI</option>
                          <option value="BANI">BANI</option>
                          <option value="BOLINAO">BOLINAO</option>
                          <option value="BURGOS">BURGOS</option>
                          <option value="DASOL">DASOL</option>
                          <option value="INFANTA">INFANTA</option>
                        </select>
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="accountNumber"
                        className="font-weight-bold"
                      >
                        4. Account Number/ Identification Number *
                      </label>
                      <div className="form-check">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              accountNumber: e.target.value,
                            });
                          }}
                          id="accountNumber"
                          placeholder="01 0100 1234"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="email" className="font-weight-bold">
                        5. Email Address/FB Account *
                      </label>
                      <div className="form-check">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              email: e.target.value,
                            });
                          }}
                          id="email"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="contactNumber"
                        className="font-weight-bold"
                      >
                        6. Contact Number(Mobile/Landline) *
                      </label>
                      <div className="form-check">
                        <input
                          type="text"
                          className="form-control"
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              contactNumber: e.target.value,
                            });
                          }}
                          id="contactNumber"
                          required
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="reconnectionTime"
                        className="font-weight-bold"
                      >
                        7. Pagkabit ng kuryente matapos magbayad.
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;(mark only one box per Question)
                      </label>
                      <div className="form-check">
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionTime: "within 48 hours",
                              });
                            }}
                            id="reconnectionTime48"
                            name="reconnectionTime"
                            value={"within 48 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionTime48"
                          >
                            4(within 48 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionTime: "within 72 hours",
                              });
                            }}
                            id="reconnectionTime72"
                            name="reconnectionTime"
                            value={"within 72 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionTime72"
                          >
                            3(within 72 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionTime: "within 96 hours",
                              });
                            }}
                            id="reconnectionTime96"
                            name="reconnectionTime"
                            value={"within 96 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionTime96"
                          >
                            2(within 96 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionTime: "more than 96 hours",
                              });
                            }}
                            id="reconnectionTime96up"
                            name="reconnectionTime"
                            value={"more than 96 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionTime96up"
                          >
                            1(more than 96 hours)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="name" className="font-weight-bold">
                        8. Bilis ng pagbalik ng kuryente mula sa biglaang
                        pagkawala ng serbisyo.
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;(mark only one box per Question)
                      </label>
                      <div className="form-check">
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceReturnSpeed: "within 12 hours",
                              });
                            }}
                            id="serviceReturnSpeed12"
                            name="serviceReturnSpeed"
                            value={"within 12 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceReturnSpeed12"
                          >
                            4(within 12 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceReturnSpeed: "within 24 hours",
                              });
                            }}
                            id="serviceReturnSpeed24"
                            name="serviceReturnSpeed"
                            value={"within 24 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceReturnSpeed24"
                          >
                            3(within 24 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceReturnSpeed: "within 48 hours",
                              });
                            }}
                            id="serviceReturnSpeed48"
                            name="serviceReturnSpeed"
                            value={"within 48 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceReturnSpeed48"
                          >
                            2(within 48 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceReturnSpeed: "more than 48 hours",
                              });
                            }}
                            id="serviceReturnSpeed48up"
                            name="serviceReturnSpeed"
                            value={"more than 48 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceReturnSpeed48up"
                          >
                            1(more than 48 hours)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label htmlFor="name" className="font-weight-bold">
                        9. Nakakaranas ka ba ng hindi normal na boltahe sa
                        inyong lugar? Gaano Kadalas?
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;(mark only one box per Question)
                      </label>
                      <div className="form-check">
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                voltageIssues: "hindi kailanman",
                              });
                            }}
                            id="voltageIssuesNever"
                            name="voltageIssues"
                            value={"hindi kailanman"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="voltageIssuesNever"
                          >
                            4(Hindi kailanman)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                voltageIssues: "hindi gaanong madalas",
                              });
                            }}
                            id="voltageIssuesNever2"
                            name="voltageIssues"
                            value={"hindi gaanong madalas"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="voltageIssuesNever2"
                          >
                            3(Hindi Gaanong Madalas)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                voltageIssues: "medyo madalas",
                              });
                            }}
                            id="voltageIssuesSometimes"
                            name="voltageIssues"
                            value={"medyo madalas"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="voltageIssuesSometimes"
                          >
                            2(Medyo Madalas)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                voltageIssues: "sobrang dalas",
                              });
                            }}
                            id="voltageIssuesOften"
                            name="voltageIssues"
                            value={"sobrang madalas"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="voltageIssuesOften"
                          >
                            1(Sobrang Madalas)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="reconnectionAfterPayment"
                        className="font-weight-bold"
                      >
                        10. Bilis ng pagbalik ng kuryente sa mga naputulan
                        matapos makapagbayad
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(mark only one box
                        per Question)
                      </label>
                      <div className="form-check">
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionAfterPayment: "within 24 hours",
                              });
                            }}
                            id="reconnectionAfterPayment24"
                            name="reconnectionAfterPayment"
                            value={"within 24 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionAfterPayment24"
                          >
                            4(Hindi kailanman)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionAfterPayment: "within 48 hours",
                              });
                            }}
                            id="reconnectionAfterPayment48"
                            name="reconnectionAfterPayment"
                            value={"within 48 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionAfterPayment48"
                          >
                            3(within 48 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionAfterPayment: "within 72 hours",
                              });
                            }}
                            id="reconnectionAfterPayment72"
                            name="reconnectionAfterPayment"
                            value={"within 72 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionAfterPayment72"
                          >
                            2(within 72 hours)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                reconnectionAfterPayment: "more than 72 hours",
                              });
                            }}
                            id="reconnectionAfterPayment72up"
                            name="reconnectionAfterPayment"
                            value={"more than 72 hours"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="reconnectionAfterPayment72up"
                          >
                            1(more than 72 hours)
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label
                        htmlFor="serviceCourtesy"
                        className="font-weight-bold"
                      >
                        11. Gaano kagalang sa pagbibigay ng serbisyo ang PANELCO
                        I
                        <br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(mark only one box
                        per Question)
                      </label>
                      <div className="form-check">
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceCourtesy: "magalang",
                              });
                            }}
                            id="serviceCourtesyMagalang"
                            name="serviceCourtesy"
                            value={"magalang"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceCourtesyMagalang"
                          >
                            4(Magalang)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceCourtesy: "medyo magalang",
                              });
                            }}
                            id="serviceCourtesyMedyoMagalang"
                            name="serviceCourtesy"
                            value={"medyo magalang"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceCourtesyMedyoMagalang"
                          >
                            3(Medyo Magalang)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceCourtesy: "hindi gaanong magalang",
                              });
                            }}
                            id="serviceCourtesyHGMagalang"
                            name="serviceCourtesy"
                            value={"hindi gaanong magalang"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceCourtesyHGMagalang"
                          >
                            2(Hindi Gaanong Magalang)
                          </label>
                        </div>
                        <div className=" form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input me-2"
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                serviceCourtesy: "hindi magalang",
                              });
                            }}
                            id="serviceCourtesyHindiMagalang"
                            name="serviceCourtesy"
                            value={"hindi magalang"}
                            required
                          />
                          <label
                            className="form-check-label"
                            htmlFor="serviceCourtesyHindiMagalang"
                          >
                            1(Hindi Magalang)
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="suggestions" className="font-weight-bold">
                        12. Maari kayong mag-iwan ng inyong panukala o
                        suhestiyon upang mapadali at mapaganda ang aming
                        serbisyo
                      </label>
                      <textarea
                        className="form-control"
                        id="suggestions"
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            suggestions: e.target.value,
                          });
                        }}
                        rows="4"
                        required
                      ></textarea>
                    </div>
                    <div className="form-group text-center mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary btn-lg"
                        onClick={(e) => {
                          e.preventDefault();
                          // Handle validation in each field
                          if (
                            !formData.name ||
                            !formData.respondentName ||
                            !formData.city ||
                            !formData.accountNumber ||
                            !formData.email ||
                            !formData.contactNumber ||
                            !formData.acceptPrivacyNotice
                          ) {
                            alert("Lahat ng fields ay kinakailangan.");
                            return;
                          }
                          // Handle form submission
                          if (formData.acceptPrivacyNotice) {
                            // Here you would typically send the formData to your server
                            submitCss();
                          }
                        }}
                      >
                        I-submit ang Survey
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default CustomeratisfactionSurvey;
